import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;
export const TOKEN_KEY = "dwc_ops_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY) || "";
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const auth = () => ({ headers: { Authorization: `Bearer ${getToken()}` } });

export const ops = {
  get: (path, params) => axios.get(`${API}/api/ops${path}`, { ...auth(), params }).then((r) => r.data),
  post: (path, body) => axios.post(`${API}/api/ops${path}`, body, auth()).then((r) => r.data),
  put: (path, body) => axios.put(`${API}/api/ops${path}`, body, auth()).then((r) => r.data),
  del: (path) => axios.delete(`${API}/api/ops${path}`, auth()).then((r) => r.data),
};

export const apiError = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return e?.message || "Something went wrong";
};

export const todayISO = () => new Date().toLocaleDateString("en-CA");
export const fmtDate = (iso) => (iso ? new Date(`${iso}T00:00:00`).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" }) : "—");
export const fmtDT = (iso) => (iso ? new Date(iso).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" }) : "—");
